export default "__VITE_ASSET__DgEXQCZN__"